import { configureStore } from "@reduxjs/toolkit";
import screenReducer from "./screenSlice";
import dictionaryReducer from "./dictionarySlice";

export const store = configureStore({
  reducer: {
    screen: screenReducer,
    dictionary: dictionaryReducer,
  },
});
